// @ts-check
import { css, jsx } from '@emotion/core';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';

const style = {
  sorterText: css`
    font-weight: bolder;
  `,
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  header: css`
    background-color: white;
    border-bottom: solid 1px #e8e8e8;
    padding: 8px 0px 8px 32px;
  `,
  headerText: css`
    margin-bottom: 0px;
    font-size: 1.6rem;
  `,
};

/** @param {{ loading: boolean; header: import("react").ReactNode, staff: import("../useStaffProfiles").StaffProfile[] }} props */
function DivisionTable({ loading, header, staff }) {
  return (
    <>
      <div css={style.header}>
        <Heading type={3} weight="bolder" theme="gray" css={style.headerText}>
          {header}
        </Heading>
      </div>
      <Table
        dataSource={staff}
        columns={columns}
        showHeader={false}
        pagination={false}
        loading={loading}
        rowKey="personId"
        scroll={{ x: 670 }}
        css={css`
          .ant-table-row-cell-break-word {
            white-space: normal !important;
          }
        `}
      />
    </>
  );
};

/** @type {import("../useStaffProfiles").StaffProfileColumn[]} */
const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    render: (text, record) => {
      return (
        <Link anchor css={style.name} href={`mailto:${record.emailAddress}`}>
          {text}
        </Link>
      );
    },
    width: '250px',
  },
  {
    title: 'Title',
    dataIndex: 'title',
    width: '240px',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    render: text => <Link anchor href={`tel:${text}`}>{text}</Link>,
    width: '180px',
  },
];

export default DivisionTable;
